import React, { ReactNode } from 'react';

type InputComProps = {
  label: string;
  type?: string;
  name?: string;
  placeholder?: string;
  children?: ReactNode;
  inputHandler?: (value: React.ChangeEvent<HTMLInputElement>) => void;
  value: string | number;
  inputClasses?: string;
  labelClasses?: string;
  disabled?: boolean;
  errorMessage?: string;
  autoComplete?: 'off' | 'on';
  autoFocus?: boolean;
  required?: boolean;
};

export default function InputCom({
  label,
  type,
  name,
  placeholder,
  children,
  inputHandler,
  value,
  inputClasses,
  labelClasses,
  disabled,
  errorMessage,
  autoComplete = 'on',
  autoFocus,
  required,
}: InputComProps) {
  return (
    <div className='input-com w-full'>
      {label && (
        <label
          className={`field-label ${labelClasses || ''} ${disabled ? 'opacity-50' : ''}`}
          htmlFor={name}
        >
          {label}
          {required && <span className='ml-0.5 text-pomegranate-700'>*</span>}
        </label>
      )}

      <div className='relative'>
        <input
          placeholder={placeholder}
          value={value}
          onChange={inputHandler}
          className={`field ${errorMessage ? 'field-invalid' : ''} ${inputClasses || ''}`}
          type={type}
          id={name}
          name={name}
          disabled={disabled}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          aria-invalid={!!errorMessage}
        />
        {children}
      </div>

      {errorMessage && <span className='field-error'>{errorMessage}</span>}
    </div>
  );
}
